import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';

import css from './FieldRequiredIndicator.module.css';

/**
 * Accessible required-field marker for form labels.
 */
const FieldRequiredIndicator = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <span className={classes}>
      <span className={css.asterisk} aria-hidden="true">
        *
      </span>
      <span className={css.srOnly}>
        <FormattedMessage id="ProfileSettingsForm.fieldRequired" />
      </span>
    </span>
  );
};

export default FieldRequiredIndicator;
